import React from 'react';
import { IPurchaseContractHasPerson } from '../../../../../../Interfaces/IPerson';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { checkString } from '../../../../../core/standardFunctions';

interface IProps {
  title: string;
  idPruchaseContractRelationType: number;
  personArray: IPurchaseContractHasPerson[];
}

export const PurchaseContractRelationSummary: React.FC<IProps> = props => {
  return (
    <>
      <Box sx={{ mt: 2 }}>
        <Typography variant='h6'>{props.title}</Typography>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell width={'30%'}>Steueridentifikationsnummer</TableCell>
              <TableCell width={'35%'}>Vorname</TableCell>
              <TableCell width={'35%'}>Nachname</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {props.personArray
              .filter(
                x =>
                  x.idPurchaseContractRelationType ===
                  props.idPruchaseContractRelationType
              )
              .map(x => (
                <TableRow>
                  <TableCell>{checkString(x.TaxNumber)}</TableCell>
                  <TableCell>{checkString(x.FirstName)}</TableCell>
                  <TableCell>{checkString(x.LastName)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};
